import React from 'react';
import { Card } from '../../../shared/components/ui';

const ACCENT_CLASSES = {
  blue: {
    bg: 'bg-blue-100 dark:bg-blue-900/40',
    text: 'text-blue-600 dark:text-blue-400',
    border: 'border-blue-200 dark:border-blue-800',
  },
  emerald: {
    bg: 'bg-emerald-100 dark:bg-emerald-900/40',
    text: 'text-emerald-600 dark:text-emerald-400',
    border: 'border-emerald-200 dark:border-emerald-800',
  },
  amber: {
    bg: 'bg-amber-100 dark:bg-amber-900/40',
    text: 'text-amber-600 dark:text-amber-400',
    border: 'border-amber-200 dark:border-amber-800',
  },
  slate: {
    bg: 'bg-slate-100 dark:bg-slate-900/40',
    text: 'text-slate-600 dark:text-slate-400',
    border: 'border-slate-200 dark:border-slate-800',
  },
  red: {
    bg: 'bg-red-100 dark:bg-red-900/40',
    text: 'text-red-600 dark:text-red-400',
    border: 'border-red-200 dark:border-red-800',
  },
};

/**
 * KPICard — summary metric tile for the Insights page header.
 *
 * Props:
 *   title       - Label shown above the value
 *   value       - Pre-formatted value string (e.g., "$94.50/SF")
 *   subtitle    - Secondary context line (e.g., "completed projects only")
 *   icon        - ReactNode — SVG icon rendered in the accent circle
 *   accentColor - 'blue' | 'emerald' | 'amber' | 'slate' | 'red'
 */
export function KPICard({ title, value, subtitle, icon, accentColor = 'blue' }) {
  const accent = ACCENT_CLASSES[accentColor] || ACCENT_CLASSES.blue;

  return (
    <Card className="p-5 shadow-md border border-gray-100 dark:border-gray-800 hover:shadow-lg transition-shadow duration-200">
      <div className="flex items-start gap-4">
        {/* Colored icon circle */}
        <div
          className={`flex items-center justify-center w-11 h-11 rounded-xl flex-shrink-0 ${accent.bg} ${accent.text}`}
        >
          {icon}
        </div>

        {/* Metric */}
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider truncate">
            {title}
          </p>
          <p className="mt-1 text-2xl font-bold text-gray-900 dark:text-gray-100 leading-tight">
            {value ?? '—'}
          </p>
          {subtitle && (
            <p className="mt-1 text-xs text-gray-400 dark:text-gray-500 truncate">{subtitle}</p>
          )}
        </div>
      </div>
    </Card>
  );
}

export default KPICard;
